import { useRouter, type RouteLocationRaw } from 'vue-router';

type FallbackRouteOptions = {
  name?: string;
  query?: Record<string, string>;
};

export function useBackNavigation() {
  const router = useRouter();

  const goBack = (options: FallbackRouteOptions = {}) => {
    const historyState = window.history.state;
    const previousPath = historyState?.back as string | undefined;

    if (
      previousPath?.includes('/search/') ||
      previousPath?.includes('/favorites')
    ) {
      router.back();
    } else {
      const fallbackRoute: RouteLocationRaw = {
        name: options.name || 'MainPage',
        query: options.query,
      };
      router.replace(fallbackRoute);
    }
  };

  return {
    goBack,
  };
}
